// extracted by mini-css-extract-plugin
export default {"container":"PatientDetail_container__vMak1"};